<template>
  <span>{{ canReadPricing ? (value?.formattedAmount ?? "N/A") : "" }}</span>
</template>

<script setup lang="ts">
import { usePricingPermission } from "@/core/composables";
import type { MoneyType } from "@/core/api/graphql/types";

interface IProps {
  value?: Pick<MoneyType, "formattedAmount">;
}

defineProps<IProps>();

// Innovadis custom: hide prices when the user does not have pricing:read permission.
const { canReadPricing } = usePricingPermission();
</script>
